<template lang="pug">
div(:class='$style.container')
  div(:class='$style.warningText') !!!ЗАПРЕЩЕНО!!! Отправлять клиентам скриншоты с изображением плеера
  iframe(
      :src="path"
      width="100%"
      height="600px"
      frameborder="0"
      allow="fullscreen"
    )
</template>

<script>
export default {
  name: "PlayerDesktop",
  props: {
    url: {
      type: String,
      default: ""
    },
  },
  computed: {
    path() {
      return this.$props.url || "";
    }
  }
};
</script>

<style module lang="postcss">
.container {
  width: 100%;
}
.warningText {
   font-size: 16px;
   background-color: #FF5353;
   color: white;
   padding: 7px;
   font-weight: 600;
 }
</style>
